import { selectCurrentUserPrefersClassicView } from './selectCurrentUserPrefersClassicView'

export const selectPrefersClassicView = selectCurrentUserPrefersClassicView
